import React from 'react';
import ClaimsTableCell from './ClaimsTableCell';
import Text from '../../common/Text/Text';
import Locale from '../../Translate/Locale';

import './ClaimsTableHeader.scss';

function ClaimsTableHeader({ top }) {
  return (
    <thead style={{ top: `${top + 24}px` }}>
      <tr>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Status</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Type</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Value</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Submission date</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Shipment tracking code</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Country</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th">
          <Text styleName="title">
            <Locale>Consumer Action</Locale>
          </Text>
        </ClaimsTableCell>
        <ClaimsTableCell as="th" />
      </tr>
    </thead>
  );
}

export default ClaimsTableHeader;
